module.exports = __webpack_public_path__ + "img/20190530160700079.8cdc4189.png";